import { render, staticRenderFns } from "./ProfileTeams.vue?vue&type=template&id=1e519e72&scoped=true"
import script from "./ProfileTeams.vue?vue&type=script&lang=ts"
export * from "./ProfileTeams.vue?vue&type=script&lang=ts"
import style0 from "./ProfileTeams.vue?vue&type=style&index=0&id=1e519e72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e519e72",
  null
  
)

export default component.exports